<div class="filters-toolbar">
  <div class="filter-title-container">
    @if (totalItems >= 0) {
      <div class="filter-title">{{ 'common.totalItems' | translate }}: {{ totalItems }}</div>
    }
    <div><ng-content select="[info]"></ng-content></div>
  </div>
  <div class="block md:hidden">
    <button mat-button (click)="toggleFilters()">
      @if (!showFilters) {
        <mat-icon>filter_alt</mat-icon>
      }
      @if (showFilters) {
        <mat-icon>close</mat-icon>
      }
      {{ 'common.filter' | translate }}
    </button>
  </div>
</div>

@if (showFilters) {
  <div class="p-4">
    <div class="filters-fields grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-3 w-full">
      <ng-content></ng-content>
    </div>
  </div>
}
